// mutations.js

export default {
    updateSystemTypesList(state, sites){
        state.systemTypesList = sites
    },
};
